"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const principios = [{
  titulo: "Software siempre en cuentas del cliente.",
  detalle: "Nunca revendemos licencias ni hacemos markup."
}, {
  titulo: "Documentación técnica.",
  detalle: "Cada componente viene documentado."
}, {
  titulo: "Avances semanales como activos.",
  detalle: "No reportes de horas — componentes funcionando."
}, {
  titulo: "Flexibilidad mensual como feature.",
  detalle: "Si cambia la prioridad, pivotamos sin renegociación."
}];
export default function ComoOperamos() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="sobre-como-operamos" id="como-operamos" className="bg-background text-foreground py-24 md:py-32 overflow-hidden border-t border-border/30">
      <div className="container mx-auto px-6 md:px-8 max-w-4xl">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-normal text-foreground leading-tight mb-10">
            Cómo operamos.
          </h2>

          <div className="space-y-6 font-sans text-lg md:text-xl text-foreground/90 leading-relaxed max-w-3xl mb-16">
            <p>Operamos como Make Partner, Monday Partner, entre otras. Las alianzas son técnicas — implican capacitación continua, acceso a roadmap de plataforma y soporte directo del fabricante. No son sello de marketing.</p>

            <p className="text-muted-foreground">Pero las herramientas son medios, no fines. El stack se elige por proyecto, según lo que el negocio necesite — Make como motor de orquestación, Monday como sistema operativo del negocio, y todo lo demás (CRMs, ERPs, IA, integraciones personalizadas) según corresponda.</p>
          </div>

          <div className="border-t border-border/30 pt-12">
            <p className="font-sans text-base md:text-lg italic text-muted-foreground leading-relaxed mb-10 max-w-2xl">
              Lo que no cambia entre proyectos:
            </p>

            <div className="space-y-8">
              {principios.map((principio, i) => <PrincipioItem key={i} principio={principio} index={i} />)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}
function PrincipioItem({
  principio,
  index
}: {
  principio: {
    titulo: string;
    detalle: string;
  };
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <div ref={ref} data-index={index} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
      <h3 className="font-serif text-xl md:text-2xl text-foreground font-normal leading-tight mb-2">
        {principio.titulo}
      </h3>
      <p className="font-sans text-base md:text-lg text-muted-foreground leading-relaxed max-w-3xl">
        {principio.detalle}
      </p>
    </div>;
}